import config from '@config/seo_meta.json'
import Image from 'next/image'
import Link from 'next/link'
interface ListItem {
  alt: string
  link: string
  url: string
}
interface ListItemProps {
  item: ListItem
}
const ListItem = ({ item }: ListItemProps) => {
  const { alt, link, url } = item || {}
  return (
    <>
      {link ? (
        <Link
          className="relative col-span-3 aspect-[0.8] h-auto w-full"
          href={link}
        >
          <Image
            fill
            src={url || '/product-img-placeholder.svg'}
            alt={alt || config.openGraph.images[0].alt}
            placeholder="blur"
            blurDataURL={`${url}&blur=500`}
          />
          {alt && (
            <div className="label absolute -bottom-9 line-clamp-1">{alt}</div>
          )}
        </Link>
      ) : (
        <div className="relative col-span-3 aspect-[0.8] h-auto w-full">
          <Image
            fill
            src={url || '/product-img-placeholder.svg'}
            alt={alt || config.openGraph.images[0].alt}
            placeholder="blur"
            blurDataURL={`${url}&blur=500`}
          />
          {alt && (
            <div className="label absolute -bottom-9 line-clamp-1">{alt}</div>
          )}
        </div>
      )}
    </>
  )
}
export default ListItem
